<app-loading *ngIf="contentReady"></app-loading>

<section class="bb-page">
  <div class="bb-page-shell">

    <header class="bb-page-header">
      <div class="bb-page-title-block">
        <span class="bb-eyebrow">{{ "supplies" | transloco }}</span>
        <h2 class="bb-page-title">{{ "supplies" | transloco }}</h2>
        <p class="bb-page-subtitle">{{ "manage inventory" | transloco }}</p>
      </div>

      <div class="bb-header-actions">
        <button routerLink="/suppliesrequest" class="bb-btn bb-btn-primary">
          {{ "supplyRequest" | transloco }}
        </button>

        @if(isAdmin){
        <button *ngIf="canShowStockTransfer" routerLink="/StocktransferHistory" class="bb-btn bb-btn-secondary">
          {{ "Stock transfer" | transloco }}
        </button>

        <div class="dropdown">
          <button class="bb-btn bb-btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown">
            {{ "Pospage" | transloco }}
          </button>

          <ul class="dropdown-menu dropdown-menu-end">
            <li *ngFor="let el of allWareHouses">
              <a class="dropdown-item" (click)="applyWareHouse(el.id)">
                {{el.name}}
              </a>
            </li>
          </ul>
        </div>
        }
      </div>
    </header>

    <div class="bb-table-card bb-p-16">
      <div class="bb-table-scroll">
        <table mat-table id="stocktable" [dataSource]="dataSource" class="bb-table">

          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef> {{ "invoice" | transloco }} </th>
            <td mat-cell *matCellDef="let element">#{{element.id}} </td>
          </ng-container>

          <ng-container matColumnDef="supplier_name">
            <th mat-header-cell *matHeaderCellDef>{{ "supplier_name" | transloco }}</th>
            <td mat-cell *matCellDef="let element"> {{element.supplier_name}} </td>
          </ng-container>

          <ng-container matColumnDef="created_at">
            <th mat-header-cell *matHeaderCellDef>{{ "requested at" | transloco }} </th>
            <td mat-cell *matCellDef="let element">
              {{formatDate(element.created_at)}}
            </td>
          </ng-container>

          <ng-container matColumnDef="items">
            <th mat-header-cell *matHeaderCellDef>
              {{ "products" | transloco }}
            </th>

            <td mat-cell *matCellDef="let element">
              <div class="bb-grid bb-gap-8">

                <div *ngFor="let el of tolist(element.items); let i = index" class="bb-flex bb-items-start bb-gap-8"
                  [class.bb-hidden]="i > 2 && !element.showAllProducts">

                  <span class="bb-badge bb-badge-soft-blue">{{ i + 1 }}</span>

                  <span class="bb-text-navy bb-font-semibold">
                    {{ drawProducts(
                    el,
                    tolist(element.prices)[i],
                    tolist(element.qtys)[i],
                    tolist(element.new_price)[i],
                    tolist(element.new_qtys)[i]
                    ) }}
                  </span>
                </div>

                <button *ngIf="tolist(element.items).length > 3" type="button" class="bb-link-action"
                  (click)="element.showAllProducts = !element.showAllProducts">

                  <span *ngIf="!element.showAllProducts">
                    +{{ tolist(element.items).length - 3 }} {{ "more" | transloco }}
                  </span>

                  <span *ngIf="element.showAllProducts">
                    {{ "Show less" | transloco }}
                  </span>

                </button>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="created_by">
            <th mat-header-cell *matHeaderCellDef>{{ "requested by" | transloco }} </th>
            <td mat-cell *matCellDef="let element">
              {{element.last_name_requested_by}}
            </td>
          </ng-container>

          <ng-container matColumnDef="accepted_by">
            <th mat-header-cell *matHeaderCellDef>{{ "accepted by" | transloco }} </th>
            <td mat-cell *matCellDef="let element">
              @if(element.accepted_by == null){
              <span class="bb-text-danger bb-font-semibold">{{ "not accepted" | transloco }}</span>
              } @else {
              {{element.accepted_by}}
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="note">
            <th mat-header-cell *matHeaderCellDef>{{ "note" | transloco }} </th>
            <td mat-cell *matCellDef="let element">
              @if(element.note == undefined || element.note == "undefined"){
              {{ "not specific" | transloco }}
              }

              @else{
              {{element.note}}
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>{{ "status" | transloco }} </th>
            <td mat-cell *matCellDef="let element">
              @if(element.status == 'pending'){
              <span class="bb-badge bb-badge-warning">{{ "pending" | transloco }}</span>
              } @else if(element.status == 'accepted'){
              <span class="bb-badge bb-badge-success">{{ "approved" | transloco }}</span>
              } @else if(element.status == 'rejected')
              {
              <span class="bb-badge bb-badge-danger">{{ "rejected" | transloco }}</span>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef>{{ "type" | transloco }} </th>
            <td mat-cell *matCellDef="let element">
              @if(element.type == '0'){
              <span class="bb-badge bb-badge-success">{{ "cash" | transloco }}</span>
              }
              @if(element.type == '1'){
              <span class="bb-badge bb-badge-soft-cyan">
                {{ "credit" | transloco }} -
                {{ "not_payed" | transloco }} : {{element.not_payed}} -
                {{ "payed" | transloco }} : {{element.payed}}
              </span>
              }
              @if(element.type == '2'){
              <span class="bb-badge bb-badge-primary">
                {{ "installment" | transloco }} -
                {{ "installment_period" | transloco }} : {{element.installment_period}} -
                {{ "installment_price" | transloco }} : {{element.installment_price}}
              </span>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="delete">
            <th mat-header-cell *matHeaderCellDef class="bb-actions-th"> </th>
            <td mat-cell *matCellDef="let element" class="bb-actions-td">

              <div class="dropdown bb-action-dropdown">
                <button class="bb-icon-btn dropdown-toggle" type="button" id="dropdownMenuButton1"
                  data-bs-toggle="dropdown" aria-expanded="false">
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                </button>

                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                  <li>
                    <a class="dropdown-item" (click)="accStatement(element.phone_number)">
                      {{ "accountStatement" | transloco }}
                    </a>
                  </li>

                  <li>
                    <a class="dropdown-item" *ngIf="element.status != 'rejected' && element.status != 'accepted'"
                      (click)="acceptRequest(element.id,tolist(element.product_ids),tolist(element.new_qtys),getNewPrice(tolist(element.prices),tolist(element.qtys),tolist(element.new_price),tolist(element.new_qtys)),tolist(element.new_price),tolist(element.new_qtys),element.type,element.payed)">
                      {{ "accept" | transloco }}
                    </a>
                  </li>

                  <li>
                    <a class="dropdown-item text-danger" *ngIf="element.status != 'rejected' && element.status != 'accepted'"
                      (click)="rejectRequest(element.id)">
                      {{ "reject" | transloco }}
                    </a>
                  </li>

                  <li>
                    <a class="dropdown-item" *ngIf="element.not_payed != 'null' && element.type == '1'"
                      (click)="changeCredit(element.id,element.not_payed,element.payed)">
                      {{ "changeCredit" | transloco }}
                    </a>
                  </li>

                  <li>
                    <a class="dropdown-item" *ngIf="element.installment_price != 'null' && element.type == '2'"
                      (click)="changeInstalimentValues(element.id,element.installment_price,element.installment_period)">
                      {{ "changeInstalimentValues" | transloco }}
                    </a>
                  </li>

                  <li>
                    <a class="dropdown-item" (click)="details(element)">
                      {{ "details" | transloco }}
                    </a>
                  </li>
                </ul>
              </div>

            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>

      <mat-paginator class="bb-paginator" [length]="stockTotal" [pageSize]="10" (page)="onPaginateChange($event)">
      </mat-paginator>
    </div>

    @if (noData) {
    <div class="bb-empty-state">
      <app-nodata></app-nodata>
    </div>
    } @else {


    }

  </div>
</section>

<div *ngIf="showRejectPopUp" class="bb-modal-backdrop">
  <div class="bb-modal-card bb-modal-sm">

    <div class="bb-modal-header">
      <h4>{{ "changeCredit" | transloco }}</h4>
      <button (click)="close()" type="button" class="bb-modal-close">
        ×
      </button>
    </div>

    <div class="bb-text-center bb-mb-16">
      <svg width="96" height="96" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path opacity="0.5" fill-rule="evenodd" clip-rule="evenodd"
          d="M2 12C2 16.714 2 19.0711 3.46447 20.5355L20.5355 3.46447C19.0711 2 16.714 2 12 2C7.28595 2 4.92893 2 3.46447 3.46447C2 4.92893 2 7.28595 2 12Z"
          fill="#1C274D" />
        <path
          d="M8 4.75C8.41421 4.75 8.75 5.08579 8.75 5.5L8.75 7.25002H10.5C10.9142 7.25002 11.25 7.58581 11.25 8.00002C11.25 8.41423 10.9142 8.75002 10.5 8.75002H8.75L8.75 10.5C8.75 10.9142 8.41421 11.25 8 11.25C7.58579 11.25 7.25 10.9142 7.25 10.5L7.25 8.75002H5.5C5.08579 8.75002 4.75 8.41423 4.75 8.00002C4.75 7.58581 5.08579 7.25002 5.5 7.25002H7.25V5.5C7.25 5.08579 7.58579 4.75 8 4.75Z"
          fill="#1C274D" />
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M12.0004 21.9999C7.28633 21.9999 4.92931 21.9999 3.46484 20.5354L20.5359 3.46436C22.0004 4.92882 22.0004 7.28584 22.0004 11.9999C22.0004 16.7139 22.0004 19.071 20.5359 20.5354C19.0714 21.9999 16.7144 21.9999 12.0004 21.9999ZM18.0005 17.75C18.4147 17.75 18.7505 17.4142 18.7505 17C18.7505 16.5858 18.4147 16.25 18.0005 16.25H13.0005C12.5863 16.25 12.2505 16.5858 12.2505 17C12.2505 17.4142 12.5863 17.75 13.0005 17.75H18.0005Z"
          fill="#1C274D" />
      </svg>
    </div>

    <div class="bb-form-grid">
      <div class="bb-field">
        <label class="bb-label" for="not_payed">{{ "not_payed" | transloco }}</label>
        <input class="bb-input" type="text" id="not_payed" [(ngModel)]="not_payed"
          placeholder="{{ 'not_payed' | transloco }}" />
      </div>

      <div class="bb-field">
        <label class="bb-label" for="payed">{{ "payed" | transloco }}</label>
        <input class="bb-input" type="text" id="payed" [(ngModel)]="payed" placeholder="{{ 'payed' | transloco }}" />
      </div>
    </div>

    <div class="bb-modal-actions">
      <button (click)="onSubmit()" type="submit" class="bb-btn bb-btn-primary">
        {{ "Submit" | transloco }}
      </button>
    </div>

  </div>
</div>

<div *ngIf="showinstalimentPopUp" class="bb-modal-backdrop">
  <div class="bb-modal-card bb-modal-sm">

    <div class="bb-modal-header">
      <h4>{{ "changeInstalimentValues" | transloco }}</h4>
      <button (click)="close()" type="button" class="bb-modal-close">
        ×
      </button>
    </div>

    <div class="bb-text-center bb-mb-16">
      <svg width="96" height="96" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path opacity="0.5" fill-rule="evenodd" clip-rule="evenodd"
          d="M2 12C2 16.714 2 19.0711 3.46447 20.5355L20.5355 3.46447C19.0711 2 16.714 2 12 2C7.28595 2 4.92893 2 3.46447 3.46447C2 4.92893 2 7.28595 2 12Z"
          fill="#1C274D" />
        <path
          d="M8 4.75C8.41421 4.75 8.75 5.08579 8.75 5.5L8.75 7.25002H10.5C10.9142 7.25002 11.25 7.58581 11.25 8.00002C11.25 8.41423 10.9142 8.75002 10.5 8.75002H8.75L8.75 10.5C8.75 10.9142 8.41421 11.25 8 11.25C7.58579 11.25 7.25 10.9142 7.25 10.5L7.25 8.75002H5.5C5.08579 8.75002 4.75 8.41423 4.75 8.00002C4.75 7.58581 5.08579 7.25002 5.5 7.25002H7.25V5.5C7.25 5.08579 7.58579 4.75 8 4.75Z"
          fill="#1C274D" />
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M12.0004 21.9999C7.28633 21.9999 4.92931 21.9999 3.46484 20.5354L20.5359 3.46436C22.0004 4.92882 22.0004 7.28584 22.0004 11.9999C22.0004 16.7139 22.0004 19.071 20.5359 20.5354C19.0714 21.9999 16.7144 21.9999 12.0004 21.9999ZM18.0005 17.75C18.4147 17.75 18.7505 17.4142 18.7505 17C18.7505 16.5858 18.4147 16.25 18.0005 16.25H13.0005C12.5863 16.25 12.2505 16.5858 12.2505 17C12.2505 17.4142 12.5863 17.75 13.0005 17.75H18.0005Z"
          fill="#1C274D" />
      </svg>
    </div>

    <div class="bb-form-grid">
      <div class="bb-field">
        <label class="bb-label" for="instaliment_price">{{ "instaliment_price" | transloco }}</label>
        <input class="bb-input" type="text" id="instaliment_price" [(ngModel)]="instaliment_price"
          placeholder="{{ 'instaliment_price' | transloco }}" />
      </div>

      <div class="bb-field">
        <label class="bb-label" for="instaliment_period">{{ "instaliment_period" | transloco }}</label>
        <input class="bb-input" type="text" id="instaliment_period" [(ngModel)]="instaliment_period"
          placeholder="{{ 'instaliment_period' | transloco }}" />
      </div>
    </div>

    <div class="bb-modal-actions">
      <button (click)="onSubmitInstaliment()" type="submit" class="bb-btn bb-btn-primary">
        {{ "Submit" | transloco }}
      </button>
    </div>

  </div>
</div>